import { useEffect, useState } from 'react';
import { useAuthStore, useRemoteConfigStore } from '@lib/store';
import { Private } from './private';
import { Public } from './public';
import { Spinner } from '@shared/widgets';

export const Root = () => {
  const [loading, setLoading] = useState<boolean>(true);

  const authStore = useAuthStore();
  const remoteConfigStore = useRemoteConfigStore();

  useEffect(() => {
    (async () => {
      await remoteConfigStore.getRemoteConfig();
      setLoading(false);
    })();
  }, []);

  if (loading)
    return (
      <main className='flex h-full w-full flex-col items-center justify-center'>
        <Spinner />
      </main>
    );
  if (authStore.data) return <Private />;
  return <Public />;
};
